import gql from 'graphql-tag'

export const GET_ALL_SCHEMES = gql`
    query Scheme($endTime:date!,$startTime:date!){
        Scheme(where: {isArchieved: {_eq: false},endTime:{_gte:$endTime},startTime:{_lte:$startTime}}){
            id
            name
            description
            backgroundImage
            schemeProductPoints {
                Product {        name      }
                points
                quantity
            }
            SchemeEnrollments{
                schemeId
                partnerId
            }
            startTime
            endTime
            tnc
            teaserImage
            schemeDocumentType
            schemeDocuments
            pointMethod
            points
        }
    }`

export const GET_ALL_SCHEMES1 = gql`
    query($orgId:uuid!,$endTime:date!,$startTime:date!){
        Scheme(where: {isArchieved: {_eq: false},isSpecialScheme:{_eq: false},endTime:{_gte:$endTime},startTime:{_lte:$startTime}}){
            id
            name
            description
            backgroundImage
            schemeProductPoints {
                Product {        name      }
                points
                quantity
            }
            SchemeEnrollments(where: {partnerId: {_eq: $orgId}}){
                id earnPoint eligiblePoint myTeamEarnPoint myTeamEligiblePoint schemeId isVerified
                redemPoint redemptioInProgress transferPoints  partnerId adjustment returnOrderPoint
            }
            startTime
            endTime
            tnc
            teaserImage
            schemeDocumentType
            schemeDocuments
            criteria
            pointMethod
            points
            isHerirachyScheme
            isSpecialScheme
        }
    }`

export const GET_PAST_SCHEMES = gql`
    query Past_Schemes($endTime:date!,$orgId:uuid!, $partnerTypeId:uuid!){
        Past_Schemes:Scheme(order_by: {isSpecialScheme: desc}, where:{endTime:{_lt:$endTime},isArchieved: {_eq: false},
                                   _or:[{isSpecialScheme:{_eq: false}},{_and:[{isSpecialScheme:{_eq: true}},{PartnerType: {id: {_eq: $partnerTypeId}}}]}] }){
            id
            name
            description
            backgroundImage
            schemeProductPoints {
                Product {        name      }
                points
                quantity
            }
            SchemeEnrollments(where: {partnerId: {_eq: $orgId}}){
                id earnPoint eligiblePoint myTeamEarnPoint myTeamEligiblePoint schemeId
                redemPoint redemptioInProgress transferPoints  partnerId adjustment returnOrderPoint
            }
            startTime
            endTime
            tnc
            teaserImage
            schemeDocumentType
            schemeDocuments
            criteria
            pointMethod
            points
            isSpecialScheme
            isHerirachyScheme
        }
    }
`
export const GET_UPCOMING_SCHEMES = gql`
    query Upcoming_Schemes($startTime:date!){
        Upcoming_Schemes:Scheme(where:{startTime:{_gt:$startTime},isSpecialScheme:{_eq: false},isArchieved: {_eq: false}}){
            id
            name
            description
            backgroundImage
            schemeProductPoints {
                Product {        name      }
                points
                quantity
            }
            startTime
            endTime
            tnc
            teaserImage
            schemeDocumentType
            schemeDocuments
            criteria
            pointMethod
            points
        }
    }
`
export const GET_JOINT_SCHEMES = gql`
    query Joint_Schemes{
        Joint_Schemes:Scheme(where: {SchemeEnrollments: {}}){
            id
            name
            description
            backgroundImage
            schemeProductPoints {
                Product {        name      }
                points
                quantity
            }
            startTime
            endTime
            tnc
            teaserImage
            schemeDocumentType
            schemeDocuments
            pointMethod
            points
        }
    }
`
export const GET_SCHEME_BY_PARTNER = gql`
    query PartnerType($id:uuid!){
        PartnerType(where:{id:{_eq:$id}})
        {
            id
            specialSchemeId
        }
    }
`

export const GET_SCHEME_BY_ID = gql`
    query Scheme($id:uuid!){
        Scheme(where:{id:{_eq:$id}}){
            id
            name
            description
            backgroundImage
            SchemaPointView(order_by: {sequenceNumber: asc, productSequenceNumber: asc}){
                productname
                points
                quantity
            }
            startTime
            endTime
            tnc
            teaserImage
            schemeDocumentType
            schemeDocuments
            pointMethod
            points
            isAutoJoin
            goalPoints
            isSelfRedemption
            applicableOn
            minMonthlyPointsForEligible
            isMultiRedemptionAllowed
            isHerirachyScheme
            criteria
        }
    }
`
export const GET_SCHEME_PRODUCT_POINTS = gql`
    query schemeProductPoints($id:uuid!){
        schemeProductPoints(where:{schemeId:{_eq:$id}}){
            id
            productId
            schemeId
            points
            quantity
            createdOn
            updatedOn
        }
    }
`
export const schemapointview = gql`
    query schemapointview($id:uuid!){
        schemapointview(where:{schemeId:{_eq:$id}})
        {
            id
            productId
            schemeId
            points
            quantity}
    }
`
export const GET_OPENING_BALANCE_COUNT = gql`
    query($schemeId:uuid!,$partnerId:uuid!,$startDate:date!,$endDate:date!){
        OpeningBalance: SchemePointHistory_aggregate(where: {schemeId: {_eq: $schemeId},partnerId: {_eq: $partnerId}, month: {_gte: $startDate, _lte: $endDate}}) {
            aggregate {
                sum {
                    point
                }
            }
        },
        EarnedByMe:  SchemePointHistory_aggregate(where: { schemeId: {_eq: $schemeId},partnerId: {_eq: $partnerId}, month:{_gte: $startDate, _lte: $endDate}}) {
            aggregate {
                sum {
                    point
                }
            }
        },
        EarnedByTeam: Organizations(where: {status:{_eq: "Active"},parentPartnerId: {_eq: $partnerId}}) {
            id
        }
    }
`
export const GET_EARNED_TEAM_COUNT = gql`
    query($orgs:[uuid!],$startDate:date!,$endDate:date!){
        EarnedTeam: SchemePointHistory_aggregate(where: {partnerId: {_in: $orgs}, month: {_gte: $startDate, _lte: $endDate}}) {
            aggregate {
                sum {
                    point
                }
            }
        }
    }
`
export const GET_MY_ELIGIBLE_POINT = gql`
    query OrderItems($orgId:uuid!,$schemeId:jsonb!,$startDate:timestamptz!,$endDate:timestamptz!){
        MyEligibleCounts:OrderItems(where: {from: {_eq: $orgId}, schemePoints: {_contains:$schemeId}, createdOn: {_gte: $startDate, _lte: $endDate}}) {
            id
            schemePoints
        }
    }
`
export const GET_TEAM_ELIGIBLE_POINT = gql`
    query OrderItems($orgId:[uuid!],$schemeId:jsonb!,$startDate:timestamptz!,$endDate:timestamptz!){
        TeamEligibleCounts:OrderItems(where: {from: {_in: $orgId}, schemePoints: {_contains:$schemeId},createdOn: {_gte: $startDate, _lte: $endDate}}) {
            id
            schemePoints
        }
    }
`

export const GET_SCHEME_POINTS = gql`
    query SchemeEnrollment($schemeId:uuid!,$partnerId:uuid!){
        SchemePoints:SchemeEnrollment(where: {schemeId: {_eq:$schemeId},partnerId:{_eq:$partnerId}}) {
            id
            earnPoint
            eligiblePoint
            myTeamEarnPoint
            myTeamEligiblePoint
            schemeId
            redemPoint
            redemptioInProgress
            transferPoints
            returnOrderPoint
        }
    }`
export const GET_SCHEME_POINTS_DETAILS = gql`
    query SchemePointHistory($schemeId:uuid!,$partnerId:uuid!){
        SchemePoints:SchemePointHistory(where: {schemeId: {_eq: $schemeId},partnerId:{_eq:$partnerId}},order_by: {month: asc}) {
            id
            month
            isEligible
            eligiblePoint
            myTeamEarnPoint
            myTeamEligiblePoint
            isEligible
            schemeId
        }
    }`

export const GET_SCHEME_MONTH_POINT = gql`
    query SchemePointHistory($partnerId:uuid!,$schemeId:uuid!){
        SchemePointHistory(where: {partnerId: {_eq: $partnerId}, schemeId: {_eq: $schemeId}}) {
            month
            eligiblePoint
            earnPoint
            point
            createdOn
            id
            schemeId
        }
    }
`
export const GET_SCHEME_PROGRESS = gql`
    query SchemeEnrollment($partnerId:uuid!,$schemeId:uuid!){
        SchemeEnrollment(where: {partnerId: {_eq: $partnerId}, schemeId: {_eq: $schemeId}}) {
            eligiblePoint
            earnPoint
        }
    }
`

export const GET_REDEEMPTION_HISTORY = gql`
    query($partnerId:uuid!,$schemeId:uuid!){
        Redemption(where: {partnerId: {_eq: $partnerId}, schemeId: {_eq: $schemeId}}){
            id
            partnerId
            schemeId
            goalId
            points
            status
            createdBy
            approvedBy
            rejectedBy
            createdOn
            goalName
            approvalObj
            redeemPoint
            approvedOn
            rejectedOn
            ApprovedBy{id name}
            RejectedBy{id name}
        }
    }
`

export const GET_SCHEME_POINTS_WITH_SCHEME_DETAIL = gql`
    query SchemeEnrollment($schemeId:uuid!,$partnerId:uuid!){
        SchemePoints:SchemeEnrollment(where: {schemeId: {_eq:$schemeId},partnerId:{_eq:$partnerId}}) {
            id
            earnPoint
            eligiblePoint
            myTeamEarnPoint
            myTeamEligiblePoint
            schemeId
            redemPoint
            redemptioInProgress
            transferPoints
            returnOrderPoint
        }
    }`
export const GET_SCHEME_DETAIL_WITH_POINTS = gql`
    query Scheme($id:uuid!,$partnerId:uuid!){
        Scheme(where:{id:{_eq:$id}}){
            id
            name
            description
            backgroundImage
            SchemaPointView(order_by: {sequenceNumber: asc, productSequenceNumber: asc}){
                productname
                points
                quantity
            }
            SchemeEnrollments(where: {partnerId: {_eq: $partnerId}}){
                id earnPoint eligiblePoint myTeamEarnPoint myTeamEligiblePoint schemeId
                redemPoint redemptioInProgress transferPoints adjustment returnOrderPoint
            }
            startTime
            endTime
            tnc
            teaserImage
            schemeDocumentType
            schemeDocuments
            pointMethod
            points
            isAutoJoin
            goalPoints
            isSelfRedemption
            applicableOn
            minMonthlyPointsForEligible
            isMultiRedemptionAllowed
            isHerirachyScheme
            criteria
            isSpecialScheme
            canRedeemPointInCurrentGoal
        }
    }
`
